import { FC, useContext } from 'react';
import './Success.scss';
import { Button } from 'carbon-components-react';
import { ArrowRight20 } from '@carbon/icons-react';
import { layoutContext } from '../RAIAssessment';
import { Scenario } from '../../data/constants';
import PublicImage from 'src/common/components/PublicImage';

interface successProps {
  contents: any;
}

const Success = (successProps: successProps) => {
  const { contents } = successProps;
  const { setCurrentScenario } = useContext(layoutContext);

  return (
    <div style={{ margin: 0 }}>
      <div className="bx--row">
        <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
          <div className="rai-assessment__success-wrapper">
            <h2 className="rai-assessment__success-headline">
              {contents.title}
            </h2>
            <p className="rai-assessment__success-description">
              {contents.copy}
            </p>
            <PublicImage
              imgPath={contents.imageSrc}
              widgetId="rai-assessment"
              alt={'alt'}
              className="rai-assessment__success-image"
            />
            <div className="rai-assessment__success-cta">
              <Button
                kind="secondary"
                className="rai-assessment__success-cta-secondary"
                onClick={() => setCurrentScenario(Scenario.questions)}
              >
                {contents.buttonBack}
              </Button>
              <Button
                className="rai-assessment__success-cta-primary"
                onClick={() => setCurrentScenario(Scenario.results)}
              >
                {contents.buttonResults}
                <ArrowRight20 className="rai-assessment__success-cta-primary-icon" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Success;
